import { useContext } from 'react'

import { GlobalNotificationsContext } from '../provider'

function useGlobalNotifications() {
  return useContext(GlobalNotificationsContext)
}

export { useGlobalNotifications }
